// Utilities
import { findDateFromDays } from "Utils/findDateFromDays";
import { getRelativeDateFromToday } from "Utils/getRelativeDateFromToday";

const defaultFromDate = findDateFromDays(-31);
const defaultToDate = getRelativeDateFromToday(1);

export class GoodDataReducerState {
  eventListenerHasBeenAttached: boolean;
  goodDataEvent: any;
  platformInfoEvent: boolean;
  filterValueChangeEvent: boolean;
  uiDrillEvent: boolean;
  dateRange: {
    selection: {
      label: string;
      value: number;
    };
    fromDate: string;
    toDate: string;
  };
  userBrowser: {
    name: string;
    version: string;
  };

  constructor(
    eventListenerHasBeenAttached?: boolean,
    goodDataEvent?: any,
    platformInfoEvent?: boolean,
    filterValueChangeEvent?: boolean,
    uiDrillEvent?: boolean,
    dateRange?: {
      selection: {
        label: string;
        value: number;
      };
      fromDate: string;
      toDate: string;
    },
    userBrowser?: {
      name: string;
      version: string;
    }
  ) {
    this.eventListenerHasBeenAttached = eventListenerHasBeenAttached || false;
    this.goodDataEvent = goodDataEvent || undefined;
    this.platformInfoEvent = platformInfoEvent || false;
    this.filterValueChangeEvent = filterValueChangeEvent || false;
    this.uiDrillEvent = uiDrillEvent || false;
    this.dateRange = dateRange || {
      selection: {
        label: "Last 30 days",
        value: -31
      },
      fromDate: defaultFromDate,
      toDate: defaultToDate
    };
    this.userBrowser = userBrowser || undefined;
  }
}
